if (!customElements.get('fancy-pagination')) {
  // TODO: Document and refactor for easier use without specific markup
  // TODO: Update loading animation to keep card skeletons
  class FancyPagination extends HTMLElement {
    constructor() {
      super();

      this.header = document.getElementById('shopify-section-header');
      this.sectionId = this.dataset.section;
      this.container = document.getElementById(`shopify-section-${this.sectionId}`).querySelector('[data-pagination-target]');
      this.pathname = window.location.pathname;
      this.handleClick = this.onClick.bind(this);
      this.handlePopState = this.onPopState.bind(this);
      this.setItems();
    }

    connectedCallback() {
      if (this.dataset.ajax != 'true' || !this.paginationItems.length || !this.container) return;

      gsap.registerPlugin(ScrollToPlugin);

      this.fadeDuration = 0.3;
      this.scrollDuration = 0.6;
      this.scrollOffset = 20;
      this.hideTimeline = gsap.timeline({ paused: true });
      this.showTimeline = gsap.timeline({ paused: true });
      this.addLoader();
      this.addEventListeners(true);
    }

    disconnectedCallback() {
      this.removeEventListeners(true);
    }

    setItems() {
      if (!this.container) return;

      this.list = this.container.firstElementChild;
      this.paginationItems = this.querySelectorAll('a:not([aria-disabled="true"])');
    }

    addEventListeners(initial = false) {
      this.paginationItems.forEach(paginationItem => {
        paginationItem.addEventListener('click', this.handleClick);
      });

      if (initial) {
        window.addEventListener('popstate', this.handlePopState);
      }
    }

    removeEventListeners(initial = false) {
      this.paginationItems.forEach(paginationItem => {
        paginationItem.removeEventListener('click', this.handleClick);
      });

      if (initial) {
        window.removeEventListener('popstate', this.handlePopState);
      }
    }

    addLoader() {
      if ('content' in document.createElement('template')) {
        const loaderTemplate = this.querySelector(`#PaginationLoader-${this.sectionId}`);

        if (!loaderTemplate) return;

        const loaderNode = loaderTemplate.content.cloneNode(true);

        this.container.parentElement.appendChild(loaderNode);
        this.loader = this.container.parentElement.querySelector('[data-pagination-loader]');
      }
    }

    showLoader() {
      if (this.loader) {
        gsap.to(this.loader, {
          autoAlpha: 1,
          duration: this.fadeDuration,
          ease: 'power1.in',
        });
      }
    }

    async replaceContent(url) {
      this.showLoader();

      const connection = url.includes('?') ? '&' : '?';
      const sectionUrl = `${url}${connection}section_id=${this.sectionId}`;
      const response = await fetch(sectionUrl);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const containerSource = html.getElementById(`shopify-section-${this.sectionId}`).querySelector('[data-pagination-target]');
      const paginationSource = html.querySelector(`.pagination-wrapper[data-section="${this.sectionId}"]`);

      containerSource.querySelectorAll('.scroll-card').forEach(item => item.classList.remove('scroll-card'));

      containerSource.firstElementChild.style.opacity = 0;
      const sourceImages = containerSource.querySelectorAll('img');
      const sourceImageCount = sourceImages.length;
      let loadedImageCount = 0;

      sourceImages.forEach(sourceImage => {
        sourceImage.removeAttribute('loading');
      });

      this.container.innerHTML = containerSource.innerHTML;
      this.innerHTML = paginationSource.innerHTML;
      this.updateItems();

      this.container.querySelectorAll('img').forEach(img => {
        img.addEventListener('load', () => {
          loadedImageCount++

          if (loadedImageCount == sourceImageCount) {
            this.showTimeline.invalidate().play(0);
          }
        });
      });
    }

    updateItems() {
      this.setItems();
      this.addEventListeners();
      this.buildShowTimeline();
    }

    buildShowTimeline() {
      this.showTimeline.clear().to(this.loader, {
        autoAlpha: 0,
        duration: this.fadeDuration,
        ease: 'power1.out',
      }).to(this.list, {
        opacity: 1,
        duration: this.fadeDuration,
        ease: 'power1.in',
      }, this.fadeDuration / 2);
    }

    buildHideTimeline(url) {
      this.hideTimeline.clear().to(this.list, {
        opacity: 0,
        duration: this.fadeDuration,
        ease: 'power1.out',
      }).to(this.loader, {
        autoAlpha: 1,
        duration: this.scrollDuration,
        ease: 'power2.inOut',
      }, 0).to(window, {
        duration: this.scrollDuration,
        ease: 'power2.out',
        scrollTo: {
          y: this.container,
          offsetY: this.header.offsetHeight + this.scrollOffset,
        }
      }, 0).call(this.replaceContent.bind(this, url));
    }

    onPopState() {
      if (window.location.pathname == this.pathname) {
        this.updatePage(window.location.href, false);
      }
    }

    async updatePage(url, pushState = true) {
      this.buildHideTimeline(url);
      this.hideTimeline.invalidate().play(0);

      if (pushState) {
        window.history.pushState({}, '', url);
      }
    }

    onClick(e) {
      e.preventDefault();
      this.updatePage(e.currentTarget.href);
    }
  }

  customElements.define('fancy-pagination', FancyPagination);
}
